<template>
  <v-navigation-drawer
    v-model="drawerModel"
    absolute
    temporary
    app
    class="navigation-drawer"
    color="#4a7eba"
    theme="dark"
  >
    <!-- Header Section -->
    <div
      v-if="selectedVessel"
      class="drawer-header pa-4"
    >
      <h2 class="vessel-title">
        {{ selectedVessel.vessel }}
      </h2>
      <div class="vessel-info">
        <div class="info-item">
          <span class="label">Main Engine Speed:</span>
          <span class="value">{{ selectedVessel.meRPM }} RPM</span>
        </div>
        <div class="info-item">
          <span class="label">Main Engine Power:</span>
          <span class="value">{{ selectedVessel.mePower }} kW</span>
        </div>
        <div class="info-item">
          <span class="label">GPS Speed:</span>
          <span class="value">{{ selectedVessel.gpsSpeed }} kn</span>
        </div>
        <div class="info-item">
          <span class="label">STW:</span>
          <span class="value">{{ selectedVessel.logSpeed }} kn</span>
        </div>
        <div class="info-item">
          <span class="label">Mean Draft:</span>
          <span class="value">{{ selectedVessel.avgDraft }} m</span>
        </div>
        <div class="info-item">
          <span class="label">Last Update:</span>

          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <span
                class="value"
                v-bind="attrs"
                v-on="on"
              >
                {{ selectedVessel.date }}
              </span>
            </template>

            <span>Table contains last report obtained from vessel</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <v-list
      nav
      class="navigation-list"
    >
      <v-list-item
        v-for="item in vesselViews"
        :key="item.title"
        :title="item.title"
        class="nav-item"
        color="white"
        rounded="lg"
        @click="navigateTo(item.route)"
      >
        <v-list-item-icon>
          <v-icon class="nav-icon">
            {{ item.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title class="nav-title">
          {{
            item.title
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import defaultViewSettings from "@/domain/view_settings/data";

export default {
  name: "MainNavigationDrawer",
  data() {
    return {
      drawer: false,
      defaultViewSettings: defaultViewSettings,
    };
  },
  computed: {
    ...mapState("main", ["selectedVessel"]),
    vesselViews() {
      const views = [
        { title: "Vessel Info", icon: "mdi-ferry", route: "Vessel Info" },
        {
          title: "K-Diagram",
          icon: "mdi-chart-bell-curve-cumulative",
          route: "K-Diagram",
        },
        { title: "Fouling", icon: "mdi-sprout", route: "Fouling" },
        {
          title: "Vessel Comparisons",
          icon: "mdi-compare",
          route: "Vessel Comparisons",
        },
        { title: "Data Overview", icon: "mdi-leak", route: "Data Overview" },
        { title: "CII", icon: "mdi-chart-line", route: "CII" },
      ];

      //views.push({ title: "CII", icon: "mdi-chart-line", route: "CII" });

      if (defaultViewSettings.usesWeatherRoutingView) {
        views.push({
          title: "Weather Routing",
          icon: "mdi-compass-outline",
          route: "Weather Routing",
        });
      }
      if (defaultViewSettings.usesAlerts) {
        views.push({
          title: "Alerts Settings",
          icon: "mdi-tune",
          route: "Alerts Settings",
        });
      }
      return views;
    },
    ...mapState("main", ["isDrawerOpen"]),
    drawerModel: {
      get() {
        return this.isDrawerOpen;
      },
      set(value) {
        this.$store.commit("main/SET_DRAWER_OPEN", value);
      },
    },
  },
  methods: {
    navigateTo(route) {
      this.$router.push({
        name: route,
        params: {
          vessel: this.selectedVessel.vessel,
        },
      });
      this.drawerModel = false;
    },
  },
};
</script>

<style scoped>
.navigation-drawer {
  background: var(--color-bg) !important;
  border-right: none !important;
  width: 300px !important;
}

.drawer-header {
  background: var(--gradient-primary) !important;
}

.vessel-title {
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
  text-align: left;
}

.vessel-info {
  line-height: 1.8;
}

.info-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  color: rgba(255, 255, 255, 0.95);
}

.label {
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  font-size: 0.975rem;
}

.value {
  color: white;
  font-weight: 500;
  font-size: 0.975rem;
}

.navigation-list {
  background: white;
  border-radius: 8px;
}

.nav-item {
  margin-bottom: 1px;
  border-radius: 6px !important;
  color: var(--color-text) !important;

  transition: all 0.2s ease-in-out;
  background: transparent;
}

.nav-item:hover {
  background: var(--color-text) !important;
  color: var(--color-secondary) !important;
  transform: translateY(-0.2rem);
}

.nav-item.v-list-item--active {
  background: rgba(74, 126, 186, 0.15) !important;
  color: var(--color-secondary) !important;
  transform: translateY(-0.2rem);
}

/* Icon styling */
.nav-item .v-icon {
  color: var(--color-text) !important;
  margin-right: 8px;
  font-size: 1.5rem !important;
}

.nav-item:hover .v-icon,
.nav-item.v-list-item--active .v-icon {
  color: var(--color-secondary) !important;
}

.nav-title {
  font-size: 0.975rem;
  font-weight: 300;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .navigation-drawer {
    width: 260px !important;
  }

  .vessel-info {
    font-size: 0.8rem;
  }

  .label,
  .value {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .navigation-drawer {
    width: 240px !important;
  }
}

.divider {
  height: 5px;
}
</style>
